import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieBanner from "@/components/CookieBanner";
import LangSuggest from "@/components/LangSuggest";

const LEGACY_REDIRECTS = {
  "/serviciile-noastre": "/servicii",
  "/serviciile-noastre/debitare-laser": "/servicii/debitare-laser",
  "/serviciile-noastre/indoire-tabla-cu-abkant-cnc": "/servicii/indoire-abkant",
  "/serviciile-noastre/sudura-otel-carbon-otel-inoxidabil-aluminiu": "/servicii/sudura",
  "/serviciile-noastre/vopsitorie-in-camp-electrostatic": "/servicii/vopsitorie-electrostatica",
  "/serviciile-noastre/vopsitorie-lichida": "/servicii/vopsitorie-electrostatica",
  "/servicii/vopsitorie-lichida": "/servicii/vopsitorie-electrostatica",
  "/panouri-structural-decorative": "/produse/panouri-decorative",
  "/mobilier": "/produse/mobilier-metalic",
};

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  const legacyTarget = LEGACY_REDIRECTS[pathname.replace(/\/+$/, "")];
  if (legacyTarget) return <Navigate to={legacyTarget} replace />;

  return (
    <div className="flex min-h-screen flex-col bg-base">
      <div className="noise-fixed" aria-hidden />
      <Header />
      <div className="fixed inset-x-0 top-[88px] z-40">
        <LangSuggest />
      </div>
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}
